import {apiSlice} from '../apiSlice';

const DEVICE_URL = '/devices';

export const deviceApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getDevices: builder.query({
            query: (token) => ({
                url: `${DEVICE_URL}`,
                method: 'GET',
                headers: {
                    "x-access-token": token
                }
            }),
        })
    }),
});

export const {
    useGetDevicesQuery
} = deviceApiSlice;
